import React from 'react';

const CourseReviewMessage: React.FC = () => {
  return (
    <aside>
      <p className='text-xl'>
        Welcome, course reviewers. On the left, you can find the course proposals for this Session
        and review them. Below, you can find some important metrics regarding the status of local
        curriculum review.
      </p>
    </aside>
  );
};

export default CourseReviewMessage;
